import React, { useState, useRef, useEffect } from "react"
import { ButtonHLPure, InstructionsPure } from "../../pures";
import "./signature-base-upload-ine.css";
import { PlusBlue } from "../../../assets/logos/icons";
import IneFrontTemplate from "../../../assets/logos/icons/frente_INEjpg.jpg";
import IneBackTemplate from "../../../assets/logos/icons/vuelta_reverso.jpg";

const SignatureBaseUploadINE = (props) => {
    let {
        t,
        step,
        onHandleNext,
        onHandleBack,
        ineFrontImg,
        ineBackImg,
        toggleLoadingRequesting,
        toggleCompletedRequesting,
        toggleErrorRequesting,
        setINEFront,
        setINEBack,
        signatureData
    } = props

    const { next, back } = step;
    

    const inputFrontIne = useRef(null);
    const inputBackIne = useRef(null);

    const uploadFile = (ref) => ref.current.click();


    useEffect(() => {
        if (ineFrontImg) urlToBlob(ineFrontImg, "ineFrontImage");
        if (ineBackImg) urlToBlob(ineBackImg, "ineBackImage");
    }, []);
    
    const onImageChange = (event, set, key) => {
        let messageError = 'Ocurrió un error al cargar la imagen'
        if (event.target.files && event.target.files[0]) {
            toggleLoadingRequesting(true)
          let type = event.target.files[0].type.split("/");
          if (type[0] === "image" && event.target.files[0].type !== "image/tiff") {
            let reader = new FileReader();
            reader.onload = (e) => {
              let im = new Image();
              im.src = e.target.result;
              im.onload = () => {
                set(e.target.result);
              };
            };
            signatureData.delete(key);
            signatureData.append(key, event.target.files[0]);
            reader.readAsDataURL(event.target.files[0]);
            reader = null;
            toggleLoadingRequesting(false)
          } else {
            messageError = "Por favor selecciona una imagen válida para continuar (png, jpg, jpeg)."
            toggleLoadingRequesting(false)
            toggleErrorRequesting(messageError, 4000, false, '/')
          }
        }
    };

    const urlToBlob = async (url, key) =>
    await fetch(url)
      .then((res) => res.blob())
      .then((blob) => {
        const file = new File([blob], key + ".png");
        signatureData.delete(key);
        signatureData.append(key, file);
    });

    return(
        <div className="signatureBaseUploadINE-container">
            <div className="signatureBaseUploadINE-body">
                <div className="signatureBaseUploadINE-text-container">
                    <div className="signatureBaseUploadINE-text">
                        <InstructionsPure instructions={[t("signatureBaseUploadINE.text")]}/>
                    </div>
                </div>
                <div className="signatureBaseUploadINE-container-images">
                    <div className="signatureBaseUploadINE-ine-front">
                        <div className={"rec-signature-base"}  onClick={() => uploadFile(inputFrontIne)}>
                            <img className={"signatureBaseUploadINE-image-plus"} src={PlusBlue} width="40" />
                            <img className={(ineFrontImg) ? "signatureBaseUploadINE-image-ine " :"signatureBaseUploadINE-image-default"} src={ineFrontImg ? ineFrontImg : IneFrontTemplate } />
                        </div>
                        <p className="signatureCredretialForm-p-sub">
                            {t("signatureBaseUploadINE.ine.front")}
                        </p>
                    </div>
                    <div className="signatureBaseUploadINE-ine-back">
                        <div className={"rec-signature-base "} onClick={() => uploadFile(inputBackIne)} >
                            <img className={"signatureBaseUploadINE-image-plus"} src={PlusBlue} width="40" />
                            <img className={(ineBackImg) ? "signatureBaseUploadINE-image-ine" : "signatureBaseUploadINE-image-default"} src={ineBackImg ? ineBackImg : IneBackTemplate} />
                        </div>
                        <p className="signatureCredretialForm-p-sub">
                            {t("signatureBaseUploadINE.ine.back")}
                        </p>
                    </div>
                </div>
            </div>
            <div className="signatureBaseUploadINE-container-btns">
                <div className="signatureBaseUploadINE-btn-secundary">
                    <ButtonHLPure
                        nameBtn={back}
                        primary={false}
                        onClickBtn={onHandleBack}
                    />
                </div>
                <ButtonHLPure
                    nameBtn={next}
                    primary={true}
                    onClickBtn={onHandleNext}
                />
            </div>
            <input
                ref={inputFrontIne}
                onChange={(e) => onImageChange(e, setINEFront, "ineFrontImage")}
                type="file"
                id="fileKey"
                // accept="image/*"
                accept=".jpg, .jpeg, .png"
                style={{ display: "none" }}
            />
            <input
                ref={inputBackIne}
                onChange={(e) => onImageChange(e, setINEBack, "ineBackImage")}
                type="file"
                id="fileKey"
                // accept="image/*"
                accept=".jpg, .jpeg, .png"
                style={{ display: "none" }}
            />
        </div>
    )
}

export { SignatureBaseUploadINE as default }